import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export const TRAINER_LECTURE_CONFIRMATION_STATUS = {
  NOT_REQUESTED: "not_requested",
  PENDING: "pending",
  CONFIRMED: "confirmed",
} as const;

export type TrainerLectureConfirmationStatusApi =
  (typeof TRAINER_LECTURE_CONFIRMATION_STATUS)[keyof typeof TRAINER_LECTURE_CONFIRMATION_STATUS];

export interface TrainerLectureConfirmationApi {
  trainerId: number;
  trainerFirstName: string;
  trainerSurname: string;
  courseId: number;
  courseName: string;
  courseScheduleId: number;
  day: Date;
  timeFrom: string;
  timeTo: string;
  status: TrainerLectureConfirmationStatusApi;
  requestedAt: Date | null;
  confirmedAt: Date | null;
}

export interface TrainerLectureConfirmationsPageApi {
  total: number;
  data: TrainerLectureConfirmationApi[];
}

const fetch = (
  skip: number,
  take: number,
  trainerId?: number,
  courseId?: number,
  dateFrom?: string,
  dateTo?: string,
  status?: string,
): AxiosPromise<TrainerLectureConfirmationsPageApi> => {
  return api.get<TrainerLectureConfirmationsPageApi>(
    endpoints.TRAINER_LECTURE_CONFIRMATIONS.GET(skip, take, trainerId, courseId, dateFrom, dateTo, status),
  );
};

const sendRequest = (trainerId: number, courseScheduleId: number): AxiosPromise<void> => {
  return api.post<void>(endpoints.TRAINER_LECTURE_CONFIRMATIONS.SEND_REQUEST(trainerId, courseScheduleId));
};

export const trainerLectureConfirmationsApi = { fetch, sendRequest };
